import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import Button from '@/components/base/Button'
import useTrans from '@/hooks/useTrans'
import { formatSafe } from '@/utils/numeric'

import type { WithdrawalSuccessProps } from './types'

const WithdrawalFormSuccess = ({ inputAmount, tokenName, decimals, closeButtonVisibility }: WithdrawalSuccessProps) => {
  const trans = useTrans()

  return (
    <Stack spacing={3}>
      <Box
        display="flex"
        alignItems="center"
        flexDirection="column"
        gap="8px"
        className="py-3"
      >
        <Box display="flex" gap="4px" flexWrap="wrap" justifyContent="center">
          {trans.asset_withdrawal.you_withdrew}
          <Typography className="font-semibold whitespace-nowrap" data-testid="assets-withdraw-sent-amount">
            {inputAmount && formatSafe(inputAmount, decimals)}
          </Typography>
          {tokenName}
        </Box>
        <CheckCircleIcon className="w-[58px] h-[58px] text-[#54B762]" />
      </Box>
      <Button
        onClick={closeButtonVisibility.click}
        data-testid="assets-withdraw-btn-close"
        disabled={closeButtonVisibility.disabled}
        variant="outlined"
        size="xl"
      >
        {closeButtonVisibility.title}
      </Button>
    </Stack>
  )
}

export default WithdrawalFormSuccess
